import { describeTargetingOption } from '@/utils/audience-builder'

export interface TargetingOption {
    optionClass: string
    id: string
    name: string
}

interface TargetingOptionListProps {
    options?: TargetingOption[] | null
    label: string
}

/**
 * Behaviours and demographics an AI audience carries next to its interests (job titles, industries, education
 * levels, behaviours), each with its class. Shown apart from the interests; nothing without options.
 */
const TargetingOptionList = ({ options, label }: TargetingOptionListProps) => {
    if (!Array.isArray(options) || options.length === 0) return null

    return (
        <div className="tw:flex tw:flex-col tw:gap-1" data-testid="targeting-option-list">
            <span className="tw:text-xs tw:font-medium tw:text-gray-200">Behaviours & demographics</span>
            <ul className="tw:flex tw:flex-wrap tw:gap-1.5" aria-label={label}>
                {options.map((option) => (
                    <li
                        key={`${option.optionClass}:${option.id}`}
                        className="tw:rounded tw:border tw:border-green-300/60 tw:bg-green-300/10 tw:px-2 tw:py-0.5 tw:text-xs tw:text-green-300"
                    >
                        {describeTargetingOption(option)}
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default TargetingOptionList
